import { JobRecordT } from './Job';
import { UserT } from './Users';


export interface VariableWorkerInvoiceT {
    value: number
    rateLabel?: string
    unitsLabel: string
    verboseName: string
}

export interface WorkerT extends UserT {
    billingContact: boolean
    rating: number
    jobs: Array<JobRecordT>
    amount?: number
    // status: string // Can be: approved | denied | kicked | pending
    hourlyRate: number
}

export const WorkerObj: WorkerT = {
    id: 0,
    address: '',
    address2: '',
    addressDetails: {
        "address": "",
        "latitude": "",
        "longitude": "",
        "country": "",
        "state": "",
        "city": "",
        "address_line_one": "",
        "address_line_two": "",
        "zipcode": "",
    },
    email: '',
    firstName: '',
    lastName: '',
    profilePic: '',
    location: {
        latitude: null,
        longitude: null,
    },
    phone: '',
    isCompany: false,
    rating: 0,
    amount: 0,
    jobs: [],
    hourlyRate: 0,
    billingContact: false,
}